import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Users, UsersRound, FileText, Settings } from 'lucide-react';

const STYLES = {
  blue: {
    card: 'border-blue-200 shadow-md',
    header: 'bg-gradient-to-r from-blue-50 to-blue-100 border-b border-blue-200 p-3 sm:p-4',
    title: 'flex items-center gap-1 sm:gap-2 text-blue-900 text-sm sm:text-base',
    value: 'text-2xl sm:text-4xl font-bold text-blue-600',
  },
  green: {
    card: 'border-green-200 shadow-md',
    header: 'bg-gradient-to-r from-green-50 to-green-100 border-b border-green-200 p-3 sm:p-4',
    title: 'flex items-center gap-1 sm:gap-2 text-green-900 text-sm sm:text-base',
    value: 'text-2xl sm:text-4xl font-bold text-green-600',
  },
  purple: {
    card: 'border-purple-200 shadow-md',
    header: 'bg-gradient-to-r from-purple-50 to-purple-100 border-b border-purple-200 p-3 sm:p-4',
    title: 'flex items-center gap-1 sm:gap-2 text-purple-900 text-sm sm:text-base',
    value: 'text-2xl sm:text-4xl font-bold text-purple-600',
  },
  orange: {
    card: 'border-orange-200 shadow-md',
    header: 'bg-gradient-to-r from-orange-50 to-orange-100 border-b border-orange-200 p-3 sm:p-4',
    title: 'flex items-center gap-1 sm:gap-2 text-orange-900 text-sm sm:text-base',
    value: 'text-2xl sm:text-4xl font-bold text-orange-600',
  },
};

const StatCard = ({ icon: Icon, label, sub, value, color }) => {
  const s = STYLES[color];
  return (
    <Card className={s.card}>
      <CardHeader className={s.header}>
        <CardTitle className={s.title}>
          <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
          <span className="hidden sm:inline">Total </span>{label}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-3 sm:pt-6">
        <div className="text-center">
          <p className={s.value}>{(value || 0).toLocaleString()}</p>
          <p className="text-xs text-gray-600 mt-1 sm:mt-2 hidden sm:block">{sub}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default function SystemStatsPanel({ systemStats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-testid="system-stats-panel">
      <StatCard icon={UsersRound} label="Families" sub="Registered families" value={systemStats.totalFamilies} color="blue" />
      <StatCard icon={Users} label="Members" sub="Insured members" value={systemStats.totalMembers} color="green" />
      <StatCard icon={FileText} label="Claims" sub="Claims submitted" value={systemStats.totalClaims} color="purple" />
      <StatCard icon={Settings} label="Hospitals" sub="Registered hospitals" value={systemStats.totalHospitals} color="orange" />
    </div>
  );
}
